module.exports = __webpack_public_path__ + "img/logo_small.b9099582.svg";